import { render } from "./ChartsSection.vue?vue&type=template&id=00484c32&scoped=true"
import script from "./ChartsSection.vue?vue&type=script&lang=js"
export * from "./ChartsSection.vue?vue&type=script&lang=js"

import "./ChartsSection.vue?vue&type=style&index=0&id=00484c32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00484c32"]])

export default __exports__